import { template as template_dccdb8a2a20c4a848ef6a4ee8f5c195a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { or } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import { isPresent, isBlank } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import Portal from 'ember-stargate/components/portal';
import { service } from '@ember/service';
import SearchTag from 'eflex/components/filters/search-tag';
const LogLevels = [
    'All',
    'Alarm',
    'Warn',
    'Error'
];
export default class LogLevelFilter extends Component {
    @service
    intl;
    @tracked
    isDisplayed;
    @tracked
    includeInactive;
    constructor(){
        super(...arguments);
        this.isDisplayed = Boolean(this.args.logLevel);
        this.includeInactive = Boolean(this.args.includeInactive);
        this.args.initParam('logLevel', this.args.logLevel);
        this.args.initParam('includeInactive', this.args.includeInactive);
    }
    get searchTagLogLevel() {
        const logLevel = this.args.logLevel;
        return isBlank(logLevel) || logLevel === 'All' ? null : this.intl.t('breadcrumbs.logLevel', {
            logLevel
        });
    }
    get searchTagIncludeInactive() {
        return !this.args.includeInactive ? null : this.intl.t('breadcrumbs.includeInactive');
    }
    get logLevel() {
        return this.args.getParam('logLevel');
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    onSelected = (logLevel)=>{
        if (logLevel === 'All') {
            this.args.updateParam('logLevel', null);
            return;
        }
        this.args.updateParam('logLevel', logLevel);
    };
    toggleIncludeInteractive = (includeInteractive)=>{
        if (includeInteractive) {
            this.args.updateParam('includeInactive', true);
        } else {
            this.args.updateParam('includeInactive', null);
        }
    };
    clear = ()=>{
        this.args.updateParam('logLevel', null);
        this.args.updateParam('includeInactive', null);
    };
    static{
        template_dccdb8a2a20c4a848ef6a4ee8f5c195a(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-log-level-criteria"
        @form={{@form}}
        @label="logs.level"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{or (isPresent this.logLevel) @includeInactive}}
        @clear={{this.clear}}
        ...attributes
      >
        <@form.element
          @controlType="power-select"
          @options={{LogLevels}}
          @value={{or this.logLevel "All"}}
          @onChange={{this.onSelected}}
        as |el|>
          <el.control class="sm" />
        </@form.element>

        <@form.element
          class="mt-2"
          @controlType="checkbox"
          @value={{@includeInactive}}
          @onChange={{this.toggleIncludeInteractive}}
        as |el|>
          <el.control class="include-inactive " />
          <label class="form-label">
            {{t "controls.criteria.includeinactive"}}
          </label>
        </@form.element>
      </FilterWrapper>
    </Portal>
    <Portal @target="search-badge-tags">
      <SearchTag
        class='logLevel'
        @isDisplayed={{@logLevel}}
        @text={{this.searchTagLogLevel}}
      />
      <SearchTag
        class='includeInactive'
        @isDisplayed={{@includeInactive}}
        @text={{this.searchTagIncludeInactive}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
